import { Labels } from '@grandvision/common'
import { StoreModel } from '@grandvision/store-model'

import { normalizeString } from './string-utils'

export const createBreadcrumbs = (
  store: StoreModel,
  labels: Labels.Labels,
  storesRoute?: string
) => {
  if (!storesRoute) {
    console.error(
      'createBreadcrumbs: Could not create breadcrumbs because storesRoute was not found'
    )
    return []
  }

  return [
    {
      name: 'Home',
      url: '/',
    },
    {
      name: Labels.getLabel(labels, 'form.findStore.title'),
      url: storesRoute,
    },
    {
      name: store.town,
      url: `${storesRoute}?search=${store.town}`,
    },
    {
      name: `${store.streetName} ${store.streetNumber}`,
      url: `${storesRoute}/${store.slug}`,
    },
  ]
}

export const getBookAppointmentUrl = (bookAppointmentUrl: string) => ({ code, postalCode = '' }) =>
  `${bookAppointmentUrl}?storeId=${code}&postalCode=${postalCode}`

export const getStoreDetailUrl = (storesListUrl: string) => (store: StoreModel) =>
  `${storesListUrl}/${normalizeString(store.town)}/${store.slug || ''}`
